__turbopack_context__.v({
  "column": "NJfCWW_column",
  "column_not-hovered": "NJfCWW_column_not-hovered",
});
